/* tslint:disable */
/* eslint-disable */
export enum EnableTwoFactorAuthenticatorConflictType {
  AnAuthenticatorIsAlreadyAssigned = 'an_authenticator_is_already_assigned',
  InvalidCode = 'invalid_code'
}
